import Head from '@/components/Head/Head';
import type { StructuredDataProps } from './interfaces';

const StructuredData = ({ dataType, properties }: StructuredDataProps) => {
  const value = {
    '@context': 'https://schema.org/',
    '@type': dataType,
    ...properties,
  };

  const innerHtml = JSON.stringify(value);
  return (
    <Head>
      <script type="application/ld+json">{innerHtml}</script>
    </Head>
  );
};

export default StructuredData;
